<div class="input-group" style="width: 19rem">
  <input
    type="text"
    style="padding: 22px 35px 22px 22px; border-radius: 25px"
    placeholder="Filter by Customer or Policy"
    class="form-control"
    [(ngModel)]="searchQuery"
    [typeahead]="showOptions()"
    [typeaheadMinLength]="0"
    [optionsListTemplate]="searchTemplate" />
  <div
    class="input-group-append"
    style="cursor: pointer; position: absolute; right: 15px; top: 10px; z-index: 9"
    *ngIf="searchQuery"
    (click)="clearSearch()">
    <span style="color: #aaa; font-size: 1.2em"><i class="fa fa-close"></i></span>
  </div>
  <div class="input-group-append" style="position: absolute; right: 15px; top: 10px; z-index: 9" *ngIf="!searchQuery">
    <span style="color: #2763cd; font-size: 1.2em"><i class="fa fa-search"></i></span>
  </div>

  <ng-template #searchTemplate>
    <table class="search-results" style="width: 400px">
      <span class="hide-table" (click)="hideTable()"><i class="fa fa-close"></i></span>
      <tr (click)="searchBy('customerName')">
        <td>Search for "{{ searchQuery }}" as <span class="badge badge-primary">Customer Name</span></td>
      </tr>
      <tr (click)="searchBy('policyNumber')">
        <td>Search for "{{ searchQuery }}" as <span class="badge badge-primary">Policy Number</span></td>
      </tr>
      <tr (click)="searchBy('inspectorName')">
        <td>Search for "{{ searchQuery }}" as <span class="badge badge-primary">Inspector Name</span></td>
      </tr>
      <tr (click)="searchBy('vendorName')">
        <td>Search for "{{ searchQuery }}" as <span class="badge badge-primary">Vendor Name</span></td>
      </tr>
    </table>
  </ng-template>
</div>
